module.exports = __webpack_public_path__ + "static/media/connect.289d19b0.svg";